import '../../../define/ui/container';
import '../../../define/ui/error-dialog';
import '../../../define/ui/dialog-backdrop';
import '../../../define/ui/dialog-popup';
import '../../../define/ui/dialog-title';
import '../../../define/ui/dialog-description';
import '../../../define/ui/dialog-close';
import '../../../define/ui/controls';
import '../../../define/ui/controls-content';
import '../../../define/ui/tooltip-group';
import '../../../define/ui/controls-group';
import '../../../define/ui/buffering-indicator';
import '../../../define/ui/play-button';
import '../../../define/ui/tooltip';
import '../../../define/ui/tooltip-label';
import '../../../define/ui/tooltip-shortcut';
import '../../../define/ui/live-button';
import '../../../define/ui/mute-button';
import '../../../define/ui/volume-popover';
import '../../../define/ui/volume-slider';
import '../../../define/ui/slider-track';
import '../../../define/ui/slider-fill';
import '../../../define/ui/slider-thumb';
import '../../../define/ui/hotkey';
import '../../../define/ui/status-announcer';
import { registerIcons } from '../../../icons';
import {
  pauseIcon as pauseIconMinimal,
  playIcon as playIconMinimal,
  restartIcon as restartIconMinimal,
  spinnerIcon as spinnerIconMinimal,
  volumeHighIcon as volumeHighIconMinimal,
  volumeLowIcon as volumeLowIconMinimal,
  volumeOffIcon as volumeOffIconMinimal,
} from '../../../icons/minimal';

registerIcons('minimal', {
  pause: pauseIconMinimal,
  play: playIconMinimal,
  restart: restartIconMinimal,
  spinner: spinnerIconMinimal,
  'volume-high': volumeHighIconMinimal,
  'volume-low': volumeLowIconMinimal,
  'volume-off': volumeOffIconMinimal,
});
